/**
 * Rewrite a drama-res TOS *regional* host to the *transfer-acceleration* host.
 *
 * Only the production bucket `drama-res` has acceleration enabled, and the
 * accelerate domain is bucket-scoped — so we ONLY rewrite drama-res regional
 * hosts. Third-party TOS buckets, non-TOS URLs, already-accelerated URLs,
 * pre-signed (host-bound signature) URLs, and unparseable inputs pass through
 * unchanged.
 */
const ACCEL_ENABLED = true; // single rollback switch
const ACCEL_BUCKET = 'drama-res';
const ACCEL_HOST = `${ACCEL_BUCKET}.tos-accelerate.volces.com`;

// drama-res.tos-cn-<region>.volces.com  (e.g. drama-res.tos-cn-shanghai.volces.com)
const REGION_HOST_RE = /^drama-res\.tos-cn-[a-z]+(?:-\d)?\.volces\.com$/i;

function hasSignatureParams(u: URL): boolean {
  const keys = Array.from(u.searchParams.keys()).map((k) => k.toLowerCase());
  return keys.some(
    (k) => k === 'x-tos-signature' || k === 'x-tos-credential' || k === 'x-tos-algorithm',
  );
}

/**
 * True if the URL carries TOS pre-sign signature params (host is part of the
 * signature, so callers must NOT rewrite host or append query to it).
 * Exported so tosImage can skip signed URLs before appending x-tos-process.
 */
export function isSignedTosUrl(url: string): boolean {
  if (!url) return false;
  try {
    return hasSignatureParams(new URL(url));
  } catch {
    return false;
  }
}

export function tosAccelerate(url: string): string {
  if (!ACCEL_ENABLED || !url) return url;

  let u: URL;
  try {
    u = new URL(url);
  } catch {
    return url; // relative path / malformed → unchanged
  }

  if (!REGION_HOST_RE.test(u.hostname)) return url; // non-drama-res / third-party / already accelerate
  if (hasSignatureParams(u)) return url; // do not break pre-signed signatures

  u.hostname = ACCEL_HOST;
  return u.toString();
}
